function Clients() {
    return (
        <section className="container mx-auto">
        <div className="flex justify-center flex-wrap">
          <div
            className="w-full flex-auto md:w-auto md:flex-initial px-4 md:px-6 my-4 md:my-0"
          >
            <img src="https://firebasestorage.googleapis.com/v0/b/pusat-6ccee.appspot.com/o/basic.jpg?alt=media&token=a4cd1ffc-8498-4b69-af57-50aec70f96a6" alt="" className="mx-auto" />
          </div>
          <div
            className="w-full flex-auto md:w-auto md:flex-initial px-4 md:px-6 my-4 md:my-0"
          >
            <img src="https://firebasestorage.googleapis.com/v0/b/pusat-6ccee.appspot.com/o/intermediate.jpg?alt=media&token=a919ce2e-5c73-4d9f-9373-e648e70ed237" alt="" className="mx-auto" />
          </div>
          <div
            className="w-full flex-auto md:w-auto md:flex-initial px-4 md:px-6 my-4 md:my-0"
          >
            <img
              src="https://firebasestorage.googleapis.com/v0/b/pusat-6ccee.appspot.com/o/academy.jpg?alt=media&token=6a987a00-eb6c-4cb4-acd2-8a1c4a14519a"
              alt=""
              className="mx-auto"
            />
          </div>
          <div
            className="w-full flex-auto md:w-auto md:flex-initial px-4 md:px-6 my-4 md:my-0"
          >
            <img src="" alt="" className="mx-auto" />
          </div>
        </div>
      </section>
    )
}

export default Clients;
